import notificationError from '@/utils/functions/notificationError';
import { notification } from 'antd';
import { useMutation } from 'react-query';
import { getQuestReportAccountsReceivable } from './AccountsReceivable.service';

export function useAccountsReceivableReport() {
  return useMutation(getQuestReportAccountsReceivable, {
    onSuccess() {
      notification.success({
        message: 'Relatório de contas a receber gerado com sucesso!',
      });
    },

    onError(error) {
      notificationError(error);
    },
  });
}
